import { useSelector } from 'react-redux';
import { ExareSeatReleaseMode, InsuranceType } from '@websky/graphql';
import { getIsAnySeatsToRefund, getIsNasServiceRefundRequired, getSeatReleaseMode } from '../model';
import { getSelectedVskInsurancesByType } from '../../../../Checkout/store/order/selectors';
import { useHasPaidInsurances } from '@entities/order';
export const useCreateRefundNotifications = () => {
    const seatReleaseMode = useSelector(getSeatReleaseMode);
    const isAnySeatsToRefund = useSelector(getIsAnySeatsToRefund);
    const isNasServiceRefundRequired = useSelector(getIsNasServiceRefundRequired);
    const selectedVskInsurances = useSelector(getSelectedVskInsurancesByType);
    const showInsuranceAlphaOrSirenaMessage = useHasPaidInsurances([
        InsuranceType.AlphaInsurance,
        InsuranceType.SirenaInsurance
    ]);
    const isExareSeatReleaseOff = seatReleaseMode === ExareSeatReleaseMode.Off;
    const showCaculationMessage = !isExareSeatReleaseOff;
    const showRefundSeatsMessage = !isExareSeatReleaseOff && isAnySeatsToRefund;
    const showNasService = isNasServiceRefundRequired;
    const showVskMessage = !isNasServiceRefundRequired && !!selectedVskInsurances.length;
    const showNotifications = [
        showCaculationMessage,
        showRefundSeatsMessage,
        showNasService,
        showVskMessage,
        showInsuranceAlphaOrSirenaMessage
    ].some(notification => notification);
    return {
        showNotifications,
        notifications: {
            showCaculationMessage,
            showRefundSeatsMessage,
            showNasService,
            showVskMessage,
            showInsuranceAlphaOrSirenaMessage
        }
    };
};
